import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { currentBudgetSelector } from "../currentBudgetSelector";

export const isCurrentBudgetEditingSelector = createDraftSafeSelector(
  [currentBudgetSelector],
  (budget) => !!budget?.id,
);
